import { Component, signal } from '@angular/core';

const DISMISSED_KEY = 'warning-banner-dismissed';
const isProductionDomain = () => window.location.hostname === 'tive.ai';

@Component({
  selector: 'app-warning-banner',
  imports: [],
  templateUrl: './warning-banner.html',
  styleUrl: './warning-banner.scss',
})
export class WarningBannerComponent {
  visible = signal(isProductionDomain() && !localStorage.getItem(DISMISSED_KEY));

  dismiss() {
    this.visible.set(false);
    localStorage.setItem(DISMISSED_KEY, 'true');
  }
}
